// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__kn9Wz","inactive":"Chip_inactive__5uUsz","chipIcon":"Chip_chipIcon__DuUsa"};